<button
  #buttonFavoriteFilter
  tooltipPosition="top"
  [showDelay]="250"
  [life]="3000"
  [hideDelay]="250"
  pTooltip="{{ 'universalFilter.favorite' | translate }}"
  pButton
  type="button"
  icon="icon-favorite"
  class="p-menu-bar-button favorite"
  (click)="updatePanelFilter($event)"
  data-cy="universal-filter-favorite"></button>
<iu-prime-overlay #overlayFavourite [appendTo]="'body'" [dismissable]="false" styleClass="iu-favorite-overlay">
  @if (isDisplayFavoriteFilter) {
    <div
      data-cy="universal-filter-favorite-panel"
      id="favorite-filter-panel"
      [ngStyle]="{ right: gridView?.isZoomTargetGrid ? 'unset' : null }"
      class="favorite-options ui-overlaypanel">
      <div class="fav-header">
        <span class="fav-title">{{ 'universalFilter.favoriteTitle' | translate }}</span>
        <button
          type="button"
          class="fav-close"
          data-cy="universal-filter-favorite-close"
          [attr.aria-label]="'generic.close' | translate"
          [title]="'generic.close' | translate"
          (click)="updatePanelFilter($event)">
          <i class="icon-close" aria-hidden="true"></i>
        </button>
      </div>
      @if (gridPreferences.length > 0) {
        <div data-cy="universal-filter-favorite-list" class="saved-list">
          <ul [attr.aria-label]="'universalFilter.savedFilters' | translate">
            @for (gridPreference of gridPreferences; track gridPreference) {
              <li
                [ngClass]="[selectedGridPref?.name === gridPreference.name ? 'selected' : '']"
                data-cy="universal-filter-favorite-item"
                [attr.data-cy-favorite-item]="gridPreference.name"
                (click)="selectAndApply($event, gridPreference)">
                <span class="label" [title]="gridPreference.name">{{ gridPreference.name }}</span>
                @if (this?.gridView?.isTabTopLevel) {
                  <button
                    tooltipPosition="top"
                    [showDelay]="250"
                    [life]="3000"
                    [hideDelay]="250"
                    pTooltip="{{ 'universalFilter.isWidget' | translate }}"
                    pButton
                    type="button"
                    icon="icon-table"
                    class="fav-action p-button-default no-background"
                    [ngClass]="{ active: gridPreference.widgetID > 0 }"
                    [attr.aria-label]="'universalFilter.isWidget' | translate"
                    (click)="showWidgetEditor($event, gridPreference)"></button>
                }
                <button
                  tooltipPosition="top"
                  [showDelay]="250"
                  [life]="3000"
                  [hideDelay]="250"
                  pTooltip="{{ 'universalFilter.byDefault' | translate }}"
                  pButton
                  type="button"
                  icon="icon-favorite"
                  class="bookmark-button fav-action p-button-default no-background"
                  [ngClass]="{ active: gridPreference.isDefault }"
                  [attr.aria-label]="'universalFilter.byDefault' | translate"
                  [attr.aria-pressed]="!!gridPreference.isDefault"
                  (click)="updateDefault($event, gridPreference)"></button>
                <button
                  tooltipPosition="top"
                  [showDelay]="250"
                  [life]="3000"
                  [hideDelay]="250"
                  pTooltip="{{ 'generic.edit' | translate }}"
                  pButton
                  type="button"
                  class="fav-action p-button-default no-background"
                  icon="icon-edit-pencil"
                  [attr.aria-label]="'generic.edit' | translate"
                  (click)="editFilter($event, gridPreference)"></button>
                <button
                  tooltipPosition="top"
                  [showDelay]="250"
                  [life]="3000"
                  [hideDelay]="250"
                  pTooltip="{{ 'generic.delete' | translate }}"
                  pButton
                  type="button"
                  class="fav-action fav-delete p-button-default no-background"
                  icon="icon-delete"
                  [attr.aria-label]="'generic.delete' | translate"
                  (click)="deleteFilter($event, gridPreference)"></button>
              </li>
            }
          </ul>
        </div>
      } @else {
        <p class="fav-empty" data-cy="universal-filter-favorite-empty">
          {{ 'universalFilter.noSavedFilter' | translate }}
        </p>
      }
      <div class="save-favorite">
        <input
          #filterFavorite
          [placeholder]="'universalFilter.favoriteNamePlaceholder' | translate"
          [attr.aria-label]="'universalFilter.favoriteNamePlaceholder' | translate"
          data-cy="universal-filter-favorite-input"
          type="text"
          class="save-favorite-input p-inputtext ui-corner-all"
          (input)="favoriteName = filterFavorite.value"
          (keydown.enter)="canSave(filterFavorite.value) && saveFilter($event, filterFavorite.value)" />
        <button
          pButton
          type="button"
          class="save p-button-default p-button-primary"
          data-cy="universal-filter-favorite-save-button"
          [disabled]="!canSave(favoriteName)"
          (click)="saveFilter($event, filterFavorite.value)">
          {{ 'generic.save' | translate }}
        </button>
      </div>
    </div>
  }
</iu-prime-overlay>

@if (displayWidgetEditorModal) {
  <iu-modal-ui
    [isModalDisplay]="displayWidgetEditorModal"
    (closeModalEmitter)="this.displayWidgetEditorModal = false"
    [hasCloseBtn]="false"
    [closeOnBackdrop]="false"
    [appendTo]="'body'"
    [angularStyle]="{ 'iu-modal-body': { padding: 0 } }">
    <ng-template #vcrWidgetEditor />
  </iu-modal-ui>
}
